import { RouterModule, Routes } from '@angular/router';

/*
* Routable Components
*/
import { AppComponent } from '@pdp/app/app.component';
import { NgModule } from '@angular/core';
import { ProductContainerComponent } from '@pdp/app/product/product-container/product-container.component';
import { ProductResolveGuard } from './product/product-resolve.guard';
import { ProductReviewsResolver } from '@product-reviews/data-access';

/*
 * Variables
 */
let APP_ROUTES: Routes = [];
export const PRODUCT_APP_SHARED_ROUTES: Routes = [];

declare const APP_RUNTIME_CONTEXT: string;

/*
 * Standalone App Routes
 */
export const PRODUCT_APP_ROUTES: Routes = [
	{ path: 'p/:seoToken/:partNumber', component: ProductContainerComponent, resolve: { data: ProductResolveGuard, reviews: ProductReviewsResolver} },
	{ path: 'p/:seoToken', component: ProductContainerComponent, resolve: { data: ProductResolveGuard, reviews: ProductReviewsResolver } }
];

/*
 * Child App Routes
 */
export const PRODUCT_CHILD_APP_ROUTES: Routes = [
	{
		path: 'p/:seoToken/:partNumber',
		component: AppComponent,
		children: [
			{
				path: '',
				component: ProductContainerComponent,
				resolve: {
					data: ProductResolveGuard
				}
			}
		]
	},
	{
		path: 'p/:seoToken',
		component: AppComponent,
		children: [
			{
				path: '',
				component: ProductContainerComponent,
				resolve: {
					data: ProductResolveGuard
				}
			}
		]
	}
];


/*
 * Route assignment
 */
// Check to see if this has been defined and has a value of 'shell'
if (typeof APP_RUNTIME_CONTEXT === 'string' && APP_RUNTIME_CONTEXT.trim() === 'shell') {
	/*
	 * Runtime context is shell and NOT standalone
	 */
	// Add the child routing to the Array
	PRODUCT_APP_SHARED_ROUTES.push(...PRODUCT_CHILD_APP_ROUTES);

	// Define an empty array because it will not be used for this context but should be defined
	APP_ROUTES = [];
} else {
	/*
	 * Runtime context is standalone and NOT shell
	 */
	// Add the standard routing to the Array
	APP_ROUTES.push(...PRODUCT_APP_ROUTES);
}

@NgModule({
	imports: [
		RouterModule.forRoot(APP_ROUTES, {
			useHash: false,
			initialNavigation: 'enabledBlocking',
			onSameUrlNavigation: 'ignore',
			enableTracing: false
		})
	],
	exports: [
		RouterModule
	]
})
export class ProductAppRoutingModule {}
